import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'

import Button from './Button'

import styles from '../../styles/components/UI/Footer.module.css'

const Footer = props => {
  const contentClassName = classnames('container', styles.content)
  const onScrollToTopClick = () => {
    document.getElementById(props.markdownRemark.frontmatter.id).scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }

  return (
    <footer className={styles.footer}>
      <div className={contentClassName}>
        <p>Copyright © Bananas Estância 2019 - Todos os direitos reservados</p>

        <p className={styles.jeff}>
          Desenvolvido por{' '}
          <a
            className={styles.jeffLink}
            href='http://jefsilva.com.br/'
            target='_blank'
            rel='noopener noreferrer'
          >
            JefSilva
          </a>
        </p>
        <Button className={styles.scrollToTop} onClick={onScrollToTopClick}>
          <img src='footer/arrow-up.svg' alt='' />
        </Button>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  markdownRemark: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  })
}

const footerQuery = graphql`
  query FooterQuery {
    markdownRemark(frontmatter: { id: { eq: "intro" } }) {
      frontmatter {
        id
      }
    }
  }
`

export default () => <StaticQuery query={footerQuery} render={data => <Footer {...data} />} />
